import React from "react";
import NotFound from "../components/NotFound/NotFound";

const NotFoundPage = () => <NotFound />;
export default NotFoundPage;
